import { apiFetch, withAuth } from "../common/api";

const HOST = import.meta.env.VITE_API_HOST;

/**
 * @param {object} accessToken
 * @returns {Promise<Array<string>>}
 */
export async function fetchNames(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/locations/services/names`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
  const data = await resp.json();
  console.log("Fetched", data, "services names");
  return data;
}

/**
 * @param {object} accessToken
 * @returns {Promise<Array<ServiceRecord>>}
 */
export async function fetchCurrent(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/locations/current/services`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
  const data = await resp.json();
  console.log("Fetched services for the current location", data, "services");
  return data;
}

/**
 * @param {object} accessToken
 * @returns {Promise<Array<ServiceRecord>>}
 */
export async function fetchAll(accessToken) {
  const resp = await apiFetch(
    `${HOST}/api/v1/locations/services`,
    accessToken ? withAuth(accessToken) : undefined,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }

  const data = await resp.json();
  console.log("Fetched", data, "services");
  return data;
}

/**
 * @param {object} accessToken
 * @param {ServiceRecord} req
 * @throws {string}
 */
export async function save(accessToken, req) {
  const opts = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  const resp = await apiFetch(
    `${HOST}/api/v1/locations/services`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
}

/**
 * @param {object} accessToken
 * @param {string} service
 * @param {number} location
 * @throws {string}
 */
export async function archive(accessToken, service, location) {
  const opts = { method: "DELETE" };
  const resp = await apiFetch(
    `${HOST}/api/v1/locations/services/${service}/${location}`,
    accessToken ? withAuth(accessToken, opts) : opts,
  );
  if (resp.status != 200) {
    throw await resp.text();
  }
}
